import {useContext} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import AtomButton from '@s-ui/react-atom-button'
import {ATOM_ICON_COLORS, ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import ListBasic, {listItemsColors, listTitleSizes, listTypes} from '@adv-mt/mt-list-basic'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck'

import {ptaButtonProps} from './buttonConfig.js'

const PanelInstantOffer = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {INSTANT_OFFER_STANDALONE_PATTERN} = config.get('page')
  const {C2B_ORIGINS} = config.get('c2b')

  const literals = {
    button: i18n.t('PUBLISH_AD.STANDALONE.FORM.GET_OFFER_NOW'),
    title: i18n.t('INSTANT_OFFER.POST_DETAIL_LEAD.TITLE'),
    description: i18n.t('INSTANT_OFFER.POST_DETAIL_LEAD.DESCRIPTION'),
    benefits: [
      i18n.t('INSTANT_OFFER.POST_DETAIL_LEAD.QUICK_APPRAISAL'),
      i18n.t('INSTANT_OFFER.POST_DETAIL_LEAD.SELL_AND_FORGET'),
      i18n.t('INSTANT_OFFER.POST_DETAIL_LEAD.NO_COSTS')
    ]
  }

  const listBasicProps = {
    isSingleColumn: true,
    itemsColor: listItemsColors.CURRENT_COLOR,
    titleSize: listTitleSizes.xs,
    type: listTypes.ICON
  }

  const items = literals.benefits.map(benefit => ({
    icon: () => (
      <div className="mt-FormContactSeller-ptaList-icon">
        <IconCircleCheck size={ATOM_ICON_SIZES.medium} color={ATOM_ICON_COLORS.success} />
      </div>
    ),
    value: benefit
  }))

  return (
    <>
      <div className="mt-FormContactSeller-ptaContainer">
        <h2 className="mt-FormContactSeller-ptaTitle">{literals.title}</h2>
        <span className="mt-FormContactSeller-ptaDescription">{literals.description}</span>
        <div className="mt-FormContactSeller-ptaList">
          <ListBasic {...listBasicProps} items={items} />
        </div>
      </div>
      <AtomButton
        {...ptaButtonProps}
        aria-label={literals.button}
        href={`${INSTANT_OFFER_STANDALONE_PATTERN}?ipromo=c2b-detail-post_lead_button&origin=${C2B_ORIGINS.POST_LEAD}`}
      >
        {literals.button}
      </AtomButton>
    </>
  )
}

PanelInstantOffer.displayName = 'PanelInstantOffer'

export default PanelInstantOffer
